export default function PageTitle({ text }) {
  return (
    <h1 className="text-5xl font-extrabold text-gray-900 sm:text-center mb-8">
      {text}
    </h1>
  )
}
